var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('PostReplyListView',{attrs:{"reply-posts":_vm.replyPosts,"is-at-max-depth":_vm.isAtMaxDepth}}):_c('div',[_vm._v(" Loading... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }